export default __webpack_public_path__ + "static/media/Zen_LE.211d266e.jpg";